"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import ProductPrice from "./ProductPrice";
import ProductQuantity from "./ProductQuantity";
import { Button, Modal, Select } from "@mantine/core";
import { useCart } from "@/contexts/cartContext";
import ProductGallery from "@/components/product/ProductPage/ProductGallery";
import EarnPointsProductBadge from "@/components/product/ProductPage/EarnPointsProductBadge";
export default function ProductForm(t0) {
  const $ = _c(58);
  const {
    product,
    selectedOptions,
    setSelectedOptions,
    selectedVariant,
    setSelectedVariant,
    quantity,
    setQuantity,
    compact: t1,
    setOpen
  } = t0;
  const compact = t1 === undefined ? false : t1;
  const {
    addToCart,
    cartLoading
  } = useCart();
  const defaultVariant = product?.variants?.[0];
  const [openOption, setOpenOption] = useState(null);
  let t2;
  if ($[0] !== defaultVariant?.option_values) {
    t2 = Object.keys(defaultVariant?.option_values || {});
    $[0] = defaultVariant?.option_values;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const optionNames = t2;
  let t3;
  if ($[2] !== product.variants || $[3] !== selectedOptions || $[4] !== setQuantity || $[5] !== setSelectedOptions || $[6] !== setSelectedVariant) {
    t3 = function handleOptionChange(optionName, value) {
      const nextOptions = {
        ...selectedOptions,
        [optionName]: value
      };
      setSelectedOptions(nextOptions);
      const matchedVariant = product.variants.find(variant => Object.entries(nextOptions).every(t4 => {
        const [key, val] = t4;
        return variant?.option_values?.[key] === val;
      }));
      if (matchedVariant) {
        setSelectedVariant(matchedVariant);
        setQuantity(1);
      }
    };
    $[2] = product.variants;
    $[3] = selectedOptions;
    $[4] = setQuantity;
    $[5] = setSelectedOptions;
    $[6] = setSelectedVariant;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleOptionChange = t3;
  const isOutOfStock = (selectedVariant?.stock || 0) < 1;
  let t4;
  if ($[8] !== optionNames || $[9] !== product.variants) {
    t4 = function hasStockForCombination(testOptions) {
      return product.variants.some(variant_0 => optionNames.every(optionName_0 => variant_0?.option_values?.[optionName_0] === testOptions[optionName_0]) && (variant_0.stock || 0) > 0);
    };
    $[8] = optionNames;
    $[9] = product.variants;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const hasStockForCombination = t4;
  let t5;
  if ($[11] !== compact || $[12] !== product || $[13] !== selectedVariant) {
    t5 = compact && <div className="col-span-12 lg:col-span-3"><ProductGallery product={product} selectedVariant={selectedVariant} showThumbs={false} /></div>;
    $[11] = compact;
    $[12] = product;
    $[13] = selectedVariant;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const t6 = compact ? "col-span-12 lg:col-span-9" : "col-span-12";
  let t7;
  if ($[15] !== product || $[16] !== selectedVariant) {
    t7 = <ProductPrice product={product} selectedVariant={selectedVariant} />;
    $[15] = product;
    $[16] = selectedVariant;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== selectedVariant.loyalty_points) {
    t8 = selectedVariant?.loyalty_points > 0 && <EarnPointsProductBadge size="text-xs" points={selectedVariant.loyalty_points} />;
    $[18] = selectedVariant.loyalty_points;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== handleOptionChange || $[21] !== hasStockForCombination || $[22] !== openOption || $[23] !== optionNames || $[24] !== product.variants || $[25] !== selectedOptions) {
    t9 = <div className="space-y-3 mb-2">{optionNames.map(optionName_1 => {
        const values = [...new Set(product.variants.map(v => v?.option_values?.[optionName_1]))];
        return <div key={optionName_1}><Select size="md" readOnly={true} data={values.map(_temp)} value={selectedOptions?.[optionName_1]} label={optionName_1} onClick={() => setOpenOption(optionName_1)} /><Modal size="lg" opened={openOption === optionName_1} onClose={() => setOpenOption(null)} title={`Choose ${optionName_1}`}><div className="flex flex-col gap-2">{values.map(value_0 => {
                const isSelected = selectedOptions?.[optionName_1] === value_0;
                const testOptions_0 = {
                  ...selectedOptions,
                  [optionName_1]: value_0
                };
                const hasStock = hasStockForCombination(testOptions_0);
                return <Button size="sm" key={value_0} variant={isSelected ? "filled" : "outline"} color={isSelected ? "var(--color-primary)" : hasStock ? "var(--color-primary)" : "gray.5"} onClick={() => {
                  handleOptionChange(optionName_1, value_0);
                  setOpenOption(null);
                }} rightSection={hasStock ? " " : "Out of Stock"}>{value_0}{isSelected && " \u2713"}</Button>;
              })}</div></Modal></div>;
      })}</div>;
    $[20] = handleOptionChange;
    $[21] = hasStockForCombination;
    $[22] = openOption;
    $[23] = optionNames;
    $[24] = product.variants;
    $[25] = selectedOptions;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== t6 || $[28] !== t7 || $[29] !== t8 || $[30] !== t9) {
    t10 = <div className={t6}>{t7}{t8}{t9}</div>;
    $[27] = t6;
    $[28] = t7;
    $[29] = t8;
    $[30] = t9;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  const t11 = compact ? "col-span-12 lg:col-span-12" : "col-span-12";
  const t12 = selectedVariant?.stock || 1;
  let t13;
  if ($[32] !== quantity || $[33] !== setQuantity || $[34] !== t12) {
    t13 = <ProductQuantity quantity={quantity} setQuantity={setQuantity} max={t12} />;
    $[32] = quantity;
    $[33] = setQuantity;
    $[34] = t12;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  let t14;
  if ($[36] !== addToCart || $[37] !== compact || $[38] !== product.product_id || $[39] !== quantity || $[40] !== selectedVariant.variant_id || $[41] !== setOpen) {
    t14 = () => {
      addToCart({
        product_id: product.product_id,
        variant_id: selectedVariant.variant_id,
        quantity
      });
      if (compact) {
        setOpen?.(false);
      }
    };
    $[36] = addToCart;
    $[37] = compact;
    $[38] = product.product_id;
    $[39] = quantity;
    $[40] = selectedVariant.variant_id;
    $[41] = setOpen;
    $[42] = t14;
  } else {
    t14 = $[42];
  }
  const t15 = isOutOfStock ? "Sold Out" : "Add To Cart";
  let t16;
  if ($[43] !== cartLoading || $[44] !== isOutOfStock || $[45] !== t14 || $[46] !== t15) {
    t16 = <div className="col-span-12 lg:col-span-8"><Button className="hover:bg-secondary! transition-colors" tt="uppercase" fullWidth={true} size="md" loading={cartLoading} disabled={isOutOfStock} onClick={t14}>{t15}</Button></div>;
    $[43] = cartLoading;
    $[44] = isOutOfStock;
    $[45] = t14;
    $[46] = t15;
    $[47] = t16;
  } else {
    t16 = $[47];
  }
  let t17;
  if ($[48] !== t13 || $[49] !== t16) {
    t17 = <div className="grid grid-cols-12 gap-4 rounded-lg border border-gray-200 bg-green-50 p-3 lg:p-6">{t13}{t16}</div>;
    $[48] = t13;
    $[49] = t16;
    $[50] = t17;
  } else {
    t17 = $[50];
  }
  let t18;
  if ($[51] !== t11 || $[52] !== t17) {
    t18 = <div className={t11}>{t17}</div>;
    $[51] = t11;
    $[52] = t17;
    $[53] = t18;
  } else {
    t18 = $[53];
  }
  let t19;
  if ($[54] !== t10 || $[55] !== t18 || $[56] !== t5) {
    t19 = <div className="grid grid-cols-12 gap-1">{t5}{t10}{t18}</div>;
    $[54] = t10;
    $[55] = t18;
    $[56] = t5;
    $[57] = t19;
  } else {
    t19 = $[57];
  }
  return t19;
}
function _temp(v_0) {
  return {
    value: v_0,
    label: v_0
  };
}